export const DEFAULT_INPUT_DEBOUNCE_DELAY = 250;
export const DEFAULT_SCROLL_DEBOUNCE_DELAY = 50;
